import { ProgressStepStatus } from '@/shared/lib/progress';
import { Typography } from '@/shared/ui';
import React from 'react';
import styles from './ProgressBarStep.module.scss';

interface IProgressBarStepProps {
	type?: ProgressStepStatus;
	// width?: string;
}

export const ProgressBarStep: React.FC<IProgressBarStepProps> = ({ type = ProgressStepStatus.PENDING }) => {
	const stepsMap: Record<ProgressStepStatus, { color: string; text: string }> = {
		[ProgressStepStatus.OK]: { color: '#75DF20', text: ProgressStepStatus.OK },
		[ProgressStepStatus.FAIL]: { color: '#BD0E9E', text: ProgressStepStatus.FAIL },
		[ProgressStepStatus.PENDING]: { color: '#9DB1EB80', text: ProgressStepStatus.PENDING },
	};

	const { text, color } = stepsMap[type];

	return (
		<div className={styles.paymentStep}>
			<Typography variant='body2' color='white' as='span' className={styles.paymentStepStatusText}>
				{text}
			</Typography>
			<div className={styles.line} style={{ backgroundColor: color }}></div>
		</div>
	);
};
